import type {Dispatch, SetStateAction} from 'react'
import type {ValidationEvent} from '@/_new-code/products/campaign-forms/cdc-screen-set-wrapper/models'
import http from '@/utils/axios'
import type {CampaignData} from '@/_new-code/models/campaign/campaign-data'
import type {Question} from '@/_new-code/models/campaign/question'

export class CampaignInterestHandler {
	selectedOptionsCallbacks: (() => Question | null)[] = []

	injectedElementCallbacks: (() => string[])[] = []

	errorsCallbacks: (() => boolean)[] = []

	selectedOptions: Question[] = []

	injectedElements: string[] = []

	validationEvents: Dispatch<SetStateAction<ValidationEvent>>[] = []

	registerQuestion(
		selectedOptionCallback: () => Question | null,
		injectedElementCallback: () => string[],
		errorsCallback: () => boolean,
		validate: Dispatch<SetStateAction<ValidationEvent>>
	): void {
		this.selectedOptionsCallbacks.push(selectedOptionCallback)
		this.injectedElementCallbacks.push(injectedElementCallback)
		this.errorsCallbacks.push(errorsCallback)
		this.validationEvents.push(validate)
	}

	validate(): void {
		const event: ValidationEvent = {validateNow: true}
		this.validationEvents.forEach((validationEvent) => {
			validationEvent(event)
		})
	}

	getSelectedOptions(): Question[] {
		this.selectedOptions = []
		this.selectedOptionsCallbacks.forEach((callback) => {
			const selection = callback()
			if (selection) {
				this.selectedOptions.push(selection)
			}
		})

		return this.selectedOptions
	}

	getInjectedElements(): string[] {
		this.injectedElements = []
		this.injectedElementCallbacks.forEach((callback) => {
			this.injectedElements = [...this.injectedElements, ...callback()]
		})

		return this.injectedElements
	}

	isValid(): boolean {
		return this.errorsCallbacks.every((hasErrors) => !hasErrors())
	}

	async send(data: CampaignData): Promise<boolean> {
		let campaignData: Question[] = []
		const hasInjectedQuestions = this.getInjectedElements().length > 0

		if (hasInjectedQuestions) {
			campaignData = this.getSelectedOptions()
		}

		if (data.formId && data.cdcProfile.UID) {
			const requestBody: CampaignData = {
				...data,
				formResponse: campaignData,
			}
			const campaignURL = '/api/campaign/interest'
			try {
				const response = await http.post(campaignURL, requestBody, {
					timeout: 20000,
				})
				return response.status === 200
			} catch (error) {
				return false
			}
		}
		return false
	}
}
